import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 tenant_retrieve_brand_stock_age_category_data: { message: "idle" },
};

export const tenant_retrieve_brand_stock_age_category_data_Slice = createSlice({
 name: "tenant_retrieve_brand_stock_age_category_data",
 initialState,
 reducers: {
  success_tenant_retrieve_brand_stock_age_category_data: (state, action) => {
   state.tenant_retrieve_brand_stock_age_category_data = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_tenant_retrieve_brand_stock_age_category_data: (state, action) => {
   state.tenant_retrieve_brand_stock_age_category_data = { status: app_consts.FAIL, message: action.payload };
  },
  reset_tenant_retrieve_brand_stock_age_category_data: (state) => {
   state.tenant_retrieve_brand_stock_age_category_data = { status: app_consts.IDLE };
  },
  loading_tenant_retrieve_brand_stock_age_category_data: (state) => {
   state.tenant_retrieve_brand_stock_age_category_data = { status: app_consts.LOADING };
  },
 }
});

export const { success_tenant_retrieve_brand_stock_age_category_data, fail_tenant_retrieve_brand_stock_age_category_data, reset_tenant_retrieve_brand_stock_age_category_data, loading_tenant_retrieve_brand_stock_age_category_data } = tenant_retrieve_brand_stock_age_category_data_Slice.actions;

export default tenant_retrieve_brand_stock_age_category_data_Slice.reducer;